module.exports = __webpack_public_path__ + "img/icon-address-2.52198d65.png";